module.exports = __webpack_public_path__ + "static/img/engagement-auburn.d551f83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/engagement-auburn.png
// module id = 43
// module chunks = 0